export default __webpack_public_path__ + "static/media/dessert.4f39ea78.svg";